<script>
  import Storycard from '../components/Storycard.svelte'
  import {
    stories
  } from '../stores/stories.js'
  import {
    fade,
    fly
  } from 'svelte/transition';

  //let data = $stories[0]
</script>

<h5 in:fade="{{ delay: 250, duration: 200}}" out:fade="{{duration: 250}}" class="invert">Available Stories</h5>
<div in:fly="{{ delay: 250, y: 50, duration: 200 }}" out:fade="{{duration: 250}}" style="width: 90%; margin: 0 auto;">

  {#each $stories as data}
<Storycard {...data} />
{/each}

</div>
<p style="width: 100%; height: 50px; text-align:center;" class="caption invert">More Coming Soon...</p>

<style>
h5 {
  margin-left: 20px;
}
</style>
